<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
    '$route.name' () {
      if (this.$route.name === 'login') {
        this.$store.state.crumbArr = [];
      }
    }
  }
};
</script>

<style src="./common/css/index.scss" lang="scss"></style>
<style>
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue